// extracted by mini-css-extract-plugin
export var chevron = "_ma-3";
export var chevronRotated = "_ma-4";
export var image = "_ma-1";
export var imageContainer = "_ma-0";
export var shippingAddress = "_ma-2";